import { useDevice } from '#imports'
import { listCategory } from '~/resources/news'
import type { ItemCategory } from '~composables/news/interface'
export function useCategory() {
  const { isMobile } = useDevice()

  const showLoadMore = ref(true)
  const currentPage = ref(1)
  const postsPerPage = ref(isMobile ? 10 : 18)
  const offset = ref(0)
  const menuCategory = Array<ItemCategory>(...listCategory)
  return {
    postsPerPage,
    offset,
    currentPage,
    showLoadMore,
    menuCategory
  }
}
